import React, {useState} from 'react';
import background from '../assets/img/nubes.svg';

import '../assets/css/Banner.scss';
import flecha_abajo from '../assets/img/flecha_abajo.svg';
import flecha_arriba from '../assets/img/flecha_arriba.svg';

const Banner = () => {
  return (
  
  <>
    <div style={{ backgroundImage:`url(${background})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', marginTop:'25px' }} className="banner-h">
      <p className="p_title_banner ml-3">
        Descubre las ofertas, <br/>
        productos y servicios <br/>
        <strong>que las pymes tienen para ti.</strong>
      </p>
    </div>
  </>
)};

export default Banner;
